import { render, staticRenderFns } from "./menuData.vue?vue&type=template&id=458b4753&scoped=true&"
import script from "./menuData.vue?vue&type=script&lang=js&"
export * from "./menuData.vue?vue&type=script&lang=js&"
import style0 from "./menuData.vue?vue&type=style&index=0&id=458b4753&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458b4753",
  null
  
)

export default component.exports